import styled, { keyframes } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
const spinAnimation = keyframes `
  to {
    transform: rotate(360deg);
  }
`;
export const LoaderContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Svg = styled.svg `
  width: ${(props) => pxToRem(props.$width)};
  height: ${(props) => pxToRem(props.$width)};
`;
export const CircleSpinner = styled.circle `
  animation: 1s linear infinite ${spinAnimation};
  transform-origin: center;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
`;
export const CircleBackground = styled.circle `
  fill: none;
  stroke: currentColor;
  stroke-opacity: 0.125;
  stroke-dasharray: 0;
`;
